<script>
    export default {
        name: 'modal',
        props: ['value'],
        data: function () {
            return {
                internalValue: '',
                locales: null,
                locale: 'all',
                localesLoaded: true
            }
        },
        mounted: function(){
            this.locales = this.$store.state.scope.locales
            this.locale = this.$store.state.scope.locales[0].id
        },
        created: function() {
            this.internalValue = this.value;
            this.initialize();
        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(){
                this.$emit('validate');
            },
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    };
</script>
<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className" v-if="internalValue.data">
            <div class="modal-overlay" @click="close()"></div>
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article>
                    <header
                            class="modal-header"
                            id="modalTitle">
                        <figure><i class="icon icon-icon_file-edit"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Attribute <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>Nouveau</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>
                    <div>
                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-text :label="'Reference'" v-model="internalValue.data.ref"></form-text>

                                <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                    <form-text :lang="client.id" :label="'Name'" v-model="internalValue.data.translations[client.id].name"></form-text>
                                </div>

                            </tab>
                        </tabs>

                    </div>
                </article>
            </div>
        </div>
    </transition>
</template>


// WEBPACK FOOTER //
// src/modules/config/attribute/Modal.vue